<app-modal-filler-atom
  (click)="onClose()"
  [index]="10"
></app-modal-filler-atom>
<div
  class="fixed left-0 right-0 overflow-y-auto shadow md:left-0 md:top-0 md:flex md:h-full md:w-full md:items-center md:justify-center mdMax:mx-auto mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:bottom-0"
  [style.z-index]="60"
>
  <app-modal-filler-atom
    class="hidden md:block"
    [withBackdrop]="false"
    (onClick)="onClose()"
    [index]="10"
  ></app-modal-filler-atom>
  <div
    class="rounded-t-3xl bg-white p-5 md:w-2/5 md:min-w-448 md:max-w-lg md:rounded-3xl md:p-7"
    [style.z-index]="60"
  >
    @if (activeStep() === registrationStep.PONGO_STEP_PHONE) {
      <app-pongo-kiosk-phone-form
        titleKey="pongo.kiosk.link-account.title"
        labelKey="pongo.kiosk.link-account.label"
        helpKey="pongo.kiosk.link-account.help"
        [phone]="phone()"
        [defaultRegionCode]="defaultRegionCode()"
        (phoneChange)="phone.set($event)"
        [isValidating]="isValidating()"
        [errorMessage]="errorMessage()"
        [accentColor]="actionFieldColor()"
        (submitPhone)="onAttach()"
        (onClose)="onClose()"
      ></app-pongo-kiosk-phone-form>
    }
    @if (activeStep() === registrationStep.PONGO_STEP_KIOSK_CONFIRMATION) {
      <app-kiosk-confirmation-step
        (onComplete)="finish()"
        [fidelityType]="FidelityType.PONGO"
        [accentColor]="actionFieldColor()"
      ></app-kiosk-confirmation-step>
    }
    @if (activeStep() === registrationStep.PONGO_STEP_KIOSK_ACCOUNT_NOT_FOUND) {
      <app-kiosk-account-not-found-step
        [phone]="phone()"
        [fidelityType]="FidelityType.PONGO"
        [accentColor]="actionFieldColor()"
        [isRegistering]="isRegistering()"
        [errorMessage]="errorMessage()"
        (goToPhoneStep)="onGoToPhoneStep()"
        (goToRegisterStep)="onRegisterFromNotFound()"
        (onComplete)="onOrderWithoutAccount()"
      ></app-kiosk-account-not-found-step>
    }
    @if (activeStep() === registrationStep.PONGO_STEP_KIOSK_REGISTER) {
      <app-pongo-kiosk-phone-form
        titleKey="pongo.kiosk.create-account.title"
        labelKey="pongo.kiosk.create-account.label"
        [phone]="phone()"
        [defaultRegionCode]="defaultRegionCode()"
        (phoneChange)="phone.set($event)"
        [isValidating]="isValidating()"
        [errorMessage]="errorMessage()"
        [accentColor]="actionFieldColor()"
        (submitPhone)="onCreate()"
        (onClose)="onClose()"
      ></app-pongo-kiosk-phone-form>
    }
    @if (activeStep() === registrationStep.PONGO_STEP_KIOSK_REGISTER_CONFIRMATION) {
      <app-kiosk-register-confirmation-step
        (onComplete)="finish()"
        [fidelityType]="FidelityType.PONGO"
        [accentColor]="actionFieldColor()"
      ></app-kiosk-register-confirmation-step>
    }
  </div>
</div>
